module.exports = __webpack_public_path__ + "static/media/south-west-science-council.5b244d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/south-west-science-council.jpg
// module id = 187
// module chunks = 0